import { Theme } from "@mui/material/styles";

function listItem(theme: Theme | any, ownerState: any) {
    const { palette, functions, borders } = theme;
    const { isActive, isParent, openMenu } = ownerState;

    const { grey, info } = palette;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    const parentStyles = () => ({
        display: "flex",
        justifyContent: openMenu ? "space-between" : "center",
    });

    const childStyles = () => ({
        justifyContent: openMenu ? "flex-start" : "center",
        backgroundColor: isActive ? rgba(info.main, 0.8) : "",
    });

    return {
        width: "100%",
        height: "100%",
        cursor: "pointer",
        alignItems: "center",
        borderRadius: borderRadius.md,
        transition: "all 300ms linear",
        backgroundColor: isActive ? grey[600] : "",
        padding: `${pxToRem(openMenu ? 8 : 4)} ${pxToRem(openMenu ? 16 : 2)}`,
        "&:hover": {
            backgroundColor: grey[600],
            color: "#000",
        },
        ...(isParent ? parentStyles() : childStyles())
    }
}

function icon(theme: Theme) {
    const { palette } = theme;
    const { white } = palette;

    return {
        width: "24px",
        height: "24px",
        display: "grid",
        marginRight: "8px",
        placeItems: "center",
        color: white.main,
    }
}


function flag(theme: Theme, openMenu: boolean) {
    return {
        display: "flex",
        padding: "1rem",
        placeItems: "center",
        justifyContent: openMenu ? "normal" : "center",
    }
}

function languageStyle(theme: Theme) {
    return {
        cursor: 'pointer',
        color: "#fff",
        fontSize: '0.875rem',
        borderRight: "1px solid #fff",
        padding: "0rem 0.5rem",
        "&:last-child": {
            borderRight: "none"
        }
    }
}

export {
    listItem,
    icon,
    flag,
    languageStyle,
}